"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".root_0ae2c541{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.item_0ae2c541{-ms-flex-negative:0;flex-shrink:0;display:inherit}\n" }]);
exports.root = "root_0ae2c541";
exports.item = "item_0ae2c541";
//# sourceMappingURL=OverflowSet.scss.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/OverflowSet/OverflowSet.scss.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/OverflowSet/OverflowSet.scss.js
// module chunks = 1